var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mounted)?[_c('load-script',{attrs:{"attributes":{ id: _vm.scriptId },"src":_vm.scriptSrc}}),_vm._v(" "),_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }